import { ThemeConfig } from "antd"

import { DEFAULT_ANT_THEME } from "@src/app/styles/themes/default"
import { TRANSFARIO_ANT_THEME } from "@src/app/styles/themes/trransfario"

export enum THEMES {
  CRYPTIX = "Cryptix",
  TRANSFERIO = "Transferio",
}

const THEME_MAP: Record<THEMES, Partial<ThemeConfig>> = {
  [THEMES.CRYPTIX]: DEFAULT_ANT_THEME,
  [THEMES.TRANSFERIO]: TRANSFARIO_ANT_THEME,
}

export const themeKey: THEMES =
  (process.env.REACT_APP_THEME as THEMES) ?? THEMES.CRYPTIX

const themeConfig = THEME_MAP[themeKey]

export const theme: ThemeConfig = {
  components: {
    Button: {
      defaultGhostBorderColor: "transparent",
      ...themeConfig.components?.Button,
    },

    Form: {
      itemMarginBottom: 0,
      labelFontSize: 12,
      verticalLabelPadding: 0,
    },

    Input: {
      paddingBlock: 6,
      paddingBlockLG: 6,
      paddingInline: 8,
      paddingInlineLG: 8,
    },

    Pagination: {
      itemSize: 40,
      itemSizeSM: 32,
    },

    Table: {
      ...themeConfig.components?.Table,
    },
  },

  token: {
    ...themeConfig.token,
    borderRadius: 8,
    borderRadiusLG: 8,
    controlHeight: 34,
    controlHeightLG: 40,
    controlHeightSM: 32,
    fontSize: 12,
    fontSizeHeading1: 38,
  },
}
